import React, { useState, useMemo } from 'react'
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Checkbox,
  Pagination,
  Popover,
  Typography,
} from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import classes from './DataTable.module.css'
import { Dots } from '../../assets/icons'
import PrintIcon from '@mui/icons-material/Print'
import {
  ClassFielfd,
  CreditFields,
  EmployeeFielfd,
  EmployeePresenceFields,
  ExpenseFields,
  FeesFields,
  HolidayFields,
  IndividualFeesRow,
  IndividualStudentRow,
  // IndividualStudentRow,
  IndividualTeacherRow,
  RoutesField,
  SchoolFielfd,
  StudentFields,
  StudentPresenceFields,
  StudentTransportFields,
  SubjectFields,
  TeacherFields,
  TimeTableGradeFields,
  TimeTableTeacherFields,
  VanDriverField,
  VanListField,
} from './TableCells/TableCell'
import { baseURL, urls } from '../../shared/config'
import {
  setAnchorEl,
  setChoosedRow,
  setEmployeeID,
  setExpenseID,
  setHolidayId,
  setIsEdit,
  setLoader,
  setOpenAddClass,
  setOpenFeeCollection,
  setRefreshPage,
  setRowsPerPage,
  setSchoolDID,
  setSchoolDInfo,
  setSchoolID,
  setSelectedRow,
  setStudentID,
} from '../../redux/globalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import axios from 'axios'
import { ConfirmDelte } from '../ImportBox/ImportBox'

const EnhancedTable = ({
  headCells,
  search,
  emp,
  classTable,
  student,
  page,
  setPage,
  handleDetailOpen,
  handleIndividualOpen,
  // handleAdminOpen,
  teacher,
  pageFee,
  setPageFee,
  pageCount,
  fees,
  expense,
  rowData,
  school,
  setUpdate,
  route,
  vanDriver,
  vanList,
  noDataMsg,
  credits,
  holidays,
  individualfee,
  handleStopOpen,
  pages,
  studentList,
  StudentPresence,
  EmployeePresence,
  subject,
  refetch,
  individualTeacher,
  individualStudent,
  TeacherView,
  GradeView,
}) => {
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('ID')
  const [currentRow, setCurrentRow] = useState(null)
  const [confirmDelete, setConfirmDelte] = useState(false)
  // const [selected, setSelected] = useState([])
  const { loader } = useSelector((state) => state.global)
  const selected = useSelector((state) => state.global.selectedRow)
  const schoolDInfo = useSelector((state) => state.global.SchoolDInfo)

  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const anchorEl = useSelector((state) => state.global.anchorEl)
  // const [attendance, setAttendance] = useState('')
  const dispatch = useDispatch()

  // const [anchorEl, setAnchorEl] = useState(null)

  const [currentPopoverId, setCurrentPopoverId] = useState(null)

  const handlePopoverOpen = (event, id, row) => {
    const targetId = event.currentTarget
    dispatch(setAnchorEl(targetId))
    setCurrentPopoverId(id)
    dispatch(setSelectedRow([id]))
    dispatch(setSchoolDInfo(row))
  }

  const handlePopoverClose = () => {
    dispatch(setAnchorEl(null))
    setCurrentPopoverId(null)
  }
  // console.log('-------current row', currentRow)
  // console.log('------popober id', currentPopoverId)

  const openPopover = Boolean(anchorEl)

  const rows = rowData

  const handleUpdate = (row) => {
    {
      if (emp || teacher || vanDriver) {
        dispatch(setEmployeeID(row.employee_id))
      } else if (student) {
        dispatch(setStudentID(row.student_id))
      } else if (expense) {
        dispatch(setExpenseID(row.expense_id))
      } else if (holidays) {
        dispatch(setHolidayId(row.holiday_id))
      } else if (subject) {
        dispatch(setHolidayId(row.holiday_id))
      } else {
        dispatch(setSchoolID(row.school_id))
      }
    }
    setUpdate(true)
    dispatch(setSchoolDInfo(row))

    handlePopoverClose()
  }

  const handleStop = (row) => {
    // {
    //   if (emp || teacher || vanDriver) {
    //     dispatch(setEmployeeID(row.employee_id))
    //   } else if (student) {
    //     dispatch(setStudentID(row.student_id))
    //   } else if (expense) {
    //     dispatch(setExpenseID(row.expense_id))
    //   } else if (holidays) {
    //     dispatch(setHolidayId(row.holiday_id))
    //   } else {
    //     dispatch(setSchoolID(row.school_id))
    //   }
    // }
    handleStopOpen(true)
    dispatch(setSchoolDInfo(row))
    handlePopoverClose()
  }
  const handleDetail = (row) => {
    if (fees || individualfee) {
      const { student_id } = row
      // const {student_exam_fee}=row
      dispatch(setStudentID(student_id))
      handleDetailOpen()
      dispatch(setSchoolDInfo(row))
      handlePopoverClose()
    } else {
      handleDetailOpen()
      handlePopoverClose()
      dispatch(setSchoolDInfo(row))
      handlePopoverClose()
      dispatch(setChoosedRow(row))
    }
  }
  const handleSelectAllClick = (event) => {
    const newSelected = event.target.checked
      ? rows?.map((n) => (holidays ? n.holiday_id : individualfee ? n.month : n.id))
      : []

    dispatch(setSelectedRow(newSelected))
  }

  const handleClick = (event, id, row) => {
    dispatch(setSchoolDID(row?.school_id))
    // const { student_id } = clickedRow
    if (fees || individualfee) {
      dispatch(setStudentID(row.student_id))
      dispatch(setSchoolDInfo(row))
    }
    const selectedIndex = selected.indexOf(id)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = [id]
    } else {
      newSelected = []
      // if (fees && !anchorEl) {
      //   dispatch(setStudentID(''))
      //   dispatch(setSchoolDInfo([]))
      // }
    }

    dispatch(setSelectedRow(newSelected))
  }

  const handleChangePage = (event, newPage) => {
    if (fees || individualfee || pages) {
      dispatch(setRefreshPage(true))
      setPageFee(newPage)
    } else {
      setPage(newPage - 1)
    }
  }
  const handlePaginationChange = (event, newPage) => {
    handleChangePage(event, newPage)
    dispatch(setRefreshPage(true))
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(parseInt(event.target.value, 10)))
    if (fees || individualfee || pages) {
      setPageFee(1)
    } else {
      setPage(0)
    }
  }

  const isSelected = (id) => selected.indexOf(id) !== -1
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }
  const comparator = (a, b) => {
    if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string') {
      return order === 'desc'
        ? b[orderBy].localeCompare(a[orderBy])
        : a[orderBy].localeCompare(b[orderBy])
    } else {
      return order === 'desc' ? b[orderBy] - a[orderBy] : a[orderBy] - b[orderBy]
    }
  }

  const otherRows = useMemo(() => {
    if (!Array.isArray(rows)) {
      return []
    }
    if (rows?.length === 0) {
      return []
    }
    return rows?.sort(comparator).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  }, [order, orderBy, page, rows, rowsPerPage])

  const visibleFeesRows = useMemo(() => {
    if (!Array.isArray(rows)) {
      return []
    }

    // Sort the rows using the comparator function
    const sortedRows = rows?.slice().sort(comparator)

    return sortedRows
  }, [rows, comparator])

  // console.log('----otherRows',otherRows);

  const visibleRows =
    fees || individualfee || pages || individualStudent || individualTeacher
      ? visibleFeesRows
      : otherRows

  const handleDeleteClick = (row) => {
    dispatch(setLoader(true))
    handlePopoverClose()
    let apiSchool
    let message

    if (emp) {
      const { employee_id } = row
      apiSchool = `${urls.EMPLOYEE_DELETE}${employee_id}`
      message = 'Employee'
    } else if (student) {
      const { student_id } = row
      apiSchool = `${urls.STUDENT_DELETE}${student_id}`
      message = 'Student'
    } else if (teacher) {
      const { employee_id } = row
      apiSchool = `${urls.TEACHER_DELETE}${employee_id}`
      message = 'Teacher'
    } else if (expense) {
      const { expense_id } = row
      apiSchool = `${urls.EXPENSE_DELETE}${expense_id}`
      message = 'Expense'
    } else if (classTable) {
      const { grade_map_id } = row
      apiSchool = `${urls.CLASS_DELETE}${grade_map_id}`
      message = 'Grade'
    } else if (vanDriver) {
      const { employee_id } = row
      apiSchool = `${urls.DRIVER_DELETE}${employee_id}`
      message = 'Van Driver'
    } else if (vanList) {
      const { van_id } = row
      apiSchool = `${urls.VAN_DELETE}${van_id}`
      message = 'Van'
    } else if (route) {
      const { route_id } = row
      apiSchool = `${urls.ROUTE_DELETE}${route_id}`
      message = 'Route'
    } else if (holidays) {
      const { holiday_id } = row
      apiSchool = `${urls.HOLIDAY_DELETE}?holiday_id=${holiday_id}`
      message = 'Holiday'
    } else if (subject) {
      const { subject_id } = row
      apiSchool = `${urls.SUBJECT}?subject_id=${subject_id}`
      message = 'Subject'
    } else if (subject) {
      const { subject_id } = row
      apiSchool = `${urls.SUBJECT}?subject_id=${subject_id}`
      message = 'Subject'
    } else {
      const { school_id } = row
      apiSchool = `/dashboard-school-fsm/v1/school/delete?school_id=${school_id}`
      message = 'School'
    }

    axios
      .delete(`${baseURL}${apiSchool}`)
      .then(() => {
        dispatch(setRefreshPage(true))
        toast.success(`${message} Deleted Successfully!`)
        dispatch(setLoader(false))
        setConfirmDelte(false)
        refetch()
      })
      .catch((error) => {
        console.error('Error deleting school:', error)
        toast.error(`Error deleting ${message}!`)
        dispatch(setLoader(false))
        refetch()
      })
  }

  const handleStateChange = async (row) => {
    handlePopoverClose()
    dispatch(setLoader(true))
    const { student_id, student_account_status } = row
    try {
      let userStatus
      if (student_account_status == true) {
        userStatus = false
      } else {
        userStatus = true
      }
      const data = {
        student_id: student_id,
        status: userStatus,
      }
      const response = await axios.patch(`${baseURL}${urls.STUDENT_STATUS_CHNAGE}`, data)
      if (response.status === 200) {
        dispatch(setLoader(false))
        dispatch(setRefreshPage(true))
        toast.success('Status Updated!')
      } else {
        dispatch(setLoader(false))
        console.error('Failed to update status:', response.statusText)
      }
    } catch (error) {
      dispatch(setLoader(false))
      console.error('An error occurred while updating status:', error)
    }
  }
  const handleStudentAttendanceChange = async (row, status) => {
    handlePopoverClose()
    dispatch(setLoader(true))
    // const { attendance_id } = row
    const responseBody = {
      attendance_id: schoolDInfo?.attendance_id,
      attendance_type: status,
    }
    try {
      const response = await axios.patch(`${baseURL}${urls.PRESENCE_GET}`, responseBody)
      if (response?.data?.status === 200) {
        dispatch(setLoader(false))
        dispatch(setRefreshPage(true))
        toast.success('Status Updated!')
        refetch?.()
      } else {
        dispatch(setLoader(false))
        console.error('Failed to update status:', response.statusText)
      }
    } catch (error) {
      dispatch(setLoader(false))
      console.error('An error occurred while updating status:', error)
    }
  }

  if (!rows || rows?.length === 0) {
    return <div>{!loader && (noDataMsg ? noDataMsg : 'No data available')}</div>
  }
  const handleCreditChange = async (row) => {
    const responseBody = {
      employee_id: parseInt(row.employee_id, 10),
    }
    const response = await axios.patch(`${baseURL}${urls.CREDIT_ASSIGN}`, responseBody)
    if (response.data.status === 202) {
      dispatch(setLoader(false))
      dispatch(setRefreshPage(true))
      toast.success('Status Updated!')
    } else {
      dispatch(setLoader(false))
      console.error('Failed to update status:', response.statusText)
      toast.error(response?.data?.message)
    }
  }
  return (
    <Box sx={{ borderRadius: '16px' }} className={classes['data-table']}>
      <Paper
        sx={{
          width: '100%',
          mb: 2,
          borderRadius: '16px',
          boxShadow: 'none',
          border: '1px solid #F2F4F7 ',
          overflow: 'hidden',
        }}
      >
        <TableContainer className={classes.data}>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="medium">
            <TableHead sx={{ whiteSpace: 'nowrap' }}>
              <TableRow sx={{ bgcolor: 'rgba(247, 249, 252, 0.80)' }}>
                {(individualfee || fees) && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      indeterminate={selected.length > 0 && selected.length < rows?.length}
                      checked={rows?.length > 0 && selected.length === rows?.length}
                      onChange={handleSelectAllClick}
                      inputProps={{
                        'aria-label': 'select all desserts',
                      }}
                      sx={{
                        '& .MuiSvgIcon-root': {
                          borderRadius: '6px',
                        },
                      }}
                    />
                  </TableCell>
                )}

                {headCells?.map((headCell) => (
                  <TableCell
                    className={classes.headCell}
                    key={headCell.id}
                    align={route ? 'left' : 'center'}
                    padding={'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    {headCell.sortable ? (
                      <TableSortLabel
                        active
                        className={classes.headCell}
                        direction={orderBy == headCell.id ? order : 'asc'}
                        onClick={() => handleRequestSort(headCell.id)}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    ) : (
                      headCell.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleRows?.map((row, index) => {
                const isItemSelected = isSelected(
                  school
                    ? row.school_id
                    : holidays
                      ? row.holiday_id
                      : credits
                        ? row.employee_id
                        : StudentPresence || EmployeePresence
                          ? row?.user_id
                          : individualfee
                            ? row.month
                            : row._id,
                )
                const labelId = `enhanced-table-checkbox-${index}`
                // console.log('---row', row)

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={school ? row.school_id : individualfee ? row.month : row._id}
                    selected={isItemSelected}
                    sx={{ cursor: 'pointer' }}
                  >
                    {(fees || individualfee) && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': labelId,
                          }}
                          onClick={(event) =>
                            handleClick(
                              event,
                              school
                                ? row.school_id
                                : holidays
                                  ? row.holiday_id
                                  : credits
                                    ? row.employee_id
                                    : StudentPresence || EmployeePresence
                                      ? row.user_id
                                      : individualfee
                                        ? row.month
                                        : row._id,
                              row,
                            )
                          }
                        />
                      </TableCell>
                    )}

                    {emp ? (
                      <EmployeeFielfd row={row} labelId={labelId} />
                    ) : student ? (
                      <StudentFields row={row} labelId={labelId} search={search} />
                    ) : teacher ? (
                      <TeacherFields row={row} labelId={labelId} />
                    ) : fees ? (
                      <FeesFields
                        row={row}
                        labelId={labelId}
                        handleIndividualOpen={handleIndividualOpen}
                      />
                    ) : classTable ? (
                      <ClassFielfd row={row} labelId={labelId} />
                    ) : StudentPresence ? (
                      <StudentPresenceFields row={row} labelId={labelId} />
                    ) : EmployeePresence ? (
                      <EmployeePresenceFields row={row} labelId={labelId} />
                    ) : expense ? (
                      <ExpenseFields row={row} labelId={labelId} />
                    ) : subject ? (
                      <SubjectFields row={row} labelId={labelId} />
                    ) : route ? (
                      <RoutesField row={row} labelId={labelId} rowIndex={index} />
                    ) : vanDriver ? (
                      <VanDriverField row={row} labelId={labelId} rowIndex={index} />
                    ) : vanList ? (
                      <VanListField row={row} labelId={labelId} />
                    ) : credits ? (
                      <CreditFields row={row} labelId={labelId} rowIndex={index} />
                    ) : holidays ? (
                      <HolidayFields row={row} labelId={labelId} rowIndex={index} />
                    ) : individualfee ? (
                      <IndividualFeesRow row={row} labelId={labelId} rowIndex={index} />
                    ) : individualTeacher ? (
                      <IndividualTeacherRow row={row} labelId={labelId} rowIndex={index} />
                    ) : individualStudent ? (
                      <IndividualStudentRow row={row} labelId={labelId} rowIndex={index} />
                    ) : studentList ? (
                      <StudentTransportFields row={row} labelId={labelId} rowIndex={index} />
                    ) : TeacherView ? (
                      <TimeTableTeacherFields
                        row={row}
                        labelId={labelId}
                        rowIndex={index}
                        headCells={headCells}
                      />
                    ) : GradeView ? (
                      <TimeTableGradeFields
                        row={row}
                        labelId={labelId}
                        rowIndex={index}
                        headCells={headCells}
                      />
                    ) : (
                      <SchoolFielfd row={row} labelId={labelId} rowIndex={index} />
                    )}
                    {!TeacherView && !GradeView && !individualStudent && (
                      <TableCell align="right">
                        {(fees || individualfee) && row.fee_status !== 'UnPaid' ? (
                          <PrintIcon onClick={() => handleDetail(row)} sx={{ fontSize: '18px' }} />
                        ) : (
                          <>
                            {!credits && !individualfee && !fees && !TeacherView && !GradeView && (
                              <div
                                onClick={(event) =>
                                  handlePopoverOpen(event, school ? row.school_id : row._id, row)
                                }
                              >
                                <img src={Dots} alt="" />
                              </div>
                            )}
                          </>
                        )}

                        <Popover
                          open={
                            openPopover &&
                            (school
                              ? currentPopoverId === row.school_id
                              : currentPopoverId === row._id)
                          }
                          elevation={1}
                          anchorEl={anchorEl}
                          sx={{ zIndex: 100 }}
                          onClose={handlePopoverClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                        >
                          <Box className="change-status">
                            {!classTable &&
                              !holidays &&
                              !credits &&
                              !individualfee &&
                              !studentList &&
                              !subject &&
                              !student &&
                              !teacher &&
                              !StudentPresence &&
                              !EmployeePresence && (
                                <Typography
                                  className="pop-over-text"
                                  // pb={(school || emp || student || teacher || expense) && 2}
                                  onClick={() => handleDetail(row)}
                                >
                                  Details
                                </Typography>
                              )}
                            <>
                              {!individualfee &&
                                !studentList &&
                                !StudentPresence &&
                                !EmployeePresence && (
                                  <Typography
                                    className="pop-over-text"
                                    onClick={() => handleUpdate(row)}
                                  >
                                    Update
                                  </Typography>
                                )}
                              {(StudentPresence || EmployeePresence) && (
                                <>
                                  {schoolDInfo?.attendance_type === 'present' && (
                                    <>
                                      <Typography
                                        sx={{ color: '#D92C20' }}
                                        className="pop-over-text"
                                        onClick={() => handleStudentAttendanceChange(row, 'absent')}
                                      >
                                        Mark As Absent
                                      </Typography>
                                      <Typography
                                        sx={{ color: '#FDB022' }}
                                        className="pop-over-text"
                                        onClick={() => handleStudentAttendanceChange(row, 'leave')}
                                      >
                                        Mark As Leave
                                      </Typography>
                                    </>
                                  )}

                                  {schoolDInfo?.attendance_type === 'absent' && (
                                    <>
                                      <Typography
                                        sx={{ color: '#38A06C' }}
                                        className="pop-over-text"
                                        onClick={() =>
                                          handleStudentAttendanceChange(row, 'present')
                                        }
                                      >
                                        Mark As Present
                                      </Typography>
                                      <Typography
                                        sx={{ color: '#FDB022' }}
                                        className="pop-over-text"
                                        onClick={() => handleStudentAttendanceChange(row, 'leave')}
                                      >
                                        Mark On Leave
                                      </Typography>
                                    </>
                                  )}

                                  {schoolDInfo?.attendance_type === 'leave' && (
                                    <>
                                      <Typography
                                        sx={{ color: '#38A06C' }}
                                        className="pop-over-text"
                                        onClick={() =>
                                          handleStudentAttendanceChange(row, 'present')
                                        }
                                      >
                                        Mark As Present
                                      </Typography>
                                      <Typography
                                        sx={{ color: '#D92C20' }}
                                        className="pop-over-text"
                                        onClick={() => handleStudentAttendanceChange(row, 'absent')}
                                      >
                                        Mark As Absent
                                      </Typography>
                                    </>
                                  )}

                                  {schoolDInfo?.attendance_type === 'pending' && (
                                    <>
                                      <Typography
                                        sx={{ color: '#38A06C' }}
                                        className="pop-over-text"
                                        onClick={() =>
                                          handleStudentAttendanceChange(selected, 'present')
                                        }
                                      >
                                        Mark As Present
                                      </Typography>
                                      <Typography
                                        sx={{ color: '#D92C20' }}
                                        onClick={() => handleStudentAttendanceChange(row, 'absent')}
                                        className="pop-over-text"
                                      >
                                        Mark As Absent
                                      </Typography>
                                      <Typography
                                        sx={{ color: '#FDB022' }}
                                        className="pop-over-text"
                                        onClick={() => handleStudentAttendanceChange(row, 'leave')}
                                      >
                                        Mark On Leave
                                      </Typography>
                                    </>
                                  )}
                                </>
                              )}
                              {/* {classTable && (
                                <Typography
                                  className="pop-over-text"
                                  onClick={() => {
                                    dispatch(setIsEdit(true))
                                    dispatch(setSchoolDInfo(row))
                                    dispatch(setOpenAddClass(true))
                                  }}
                                >
                                  Update
                                </Typography>
                              )} */}
                              {route && (
                                <Typography
                                  className="pop-over-text"
                                  onClick={() => handleStop(row)}
                                >
                                  Add Stops
                                </Typography>
                              )}
                              {(vanDriver || teacher) && (
                                <Typography
                                  onClick={() => handleCreditChange(row)}
                                  className="pop-over-text"
                                >
                                  <span
                                    style={{
                                      color: row.employee_credit === true ? '#D84040' : '#16C47F',
                                    }}
                                    className={classes.enabletxt}
                                  >
                                    {row.employee_credit === true ? 'Disable' : 'Enable'}
                                  </span>{' '}
                                  Credits
                                </Typography>
                              )}
                              {!individualfee && !StudentPresence && !EmployeePresence && (
                                <Typography
                                  className="pop-over-text"
                                  onClick={() => {
                                    setConfirmDelte(true)
                                    setCurrentRow(row)
                                  }}
                                  sx={{ color: '#D92C20' }}
                                >
                                  Delete
                                </Typography>
                              )}

                              {student && (
                                <Typography
                                  className="pop-over-text"
                                  onClick={() => handleStateChange(row)}
                                >
                                  Make {row.student_account_status == true ? 'Inactive' : 'Active'}
                                </Typography>
                              )}
                              {studentList && (
                                <Typography
                                  className="pop-over-text"
                                  onClick={() => dispatch(setOpenFeeCollection(true))}
                                >
                                  Collect Fees
                                </Typography>
                              )}
                            </>
                          </Box>
                        </Popover>
                      </TableCell>
                    )}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {(pageFee || page) && (
          <div className={classes.tablePagination}>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={rows?.length}
              rowsPerPage={rowsPerPage}
              page={fees || individualfee || pages ? pageFee - 1 : page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              className={classes['mui-pagination']}
              sx={{
                '& .MuiTablePagination-actions': {
                  display: 'none',
                },
              }}
            />
            <div className={classes.page}>
              <Pagination
                count={
                  fees || individualfee || pages
                    ? Math.ceil(pageCount / rowsPerPage)
                    : Math.ceil(rows?.length / rowsPerPage)
                }
                page={fees || individualfee || pages ? pageFee : page + 1}
                onChange={handlePaginationChange}
                color="primary"
                className={classes['pagination-root']}
                sx={{
                  '& .MuiPaginationItem-page.Mui-selected': {
                    color: 'black',
                    bgcolor: '#F9FAFB',
                  },
                }}
              />
            </div>
          </div>
        )}
      </Paper>
      {confirmDelete && (
        <ConfirmDelte
          open={confirmDelete}
          handleDelete={() => handleDeleteClick(currentRow)}
          handleBack={() => setConfirmDelte(false)}
          refetch={refetch}
        />
      )}
    </Box>
  )
}

export default EnhancedTable
